import { EndPoints } from '../common/enums/enums';
import { amplifyApi } from '../hooks/amplifyApi';

export const editVehicle = async (newData, oldData) => {
  basicDataHasChanged(newData, oldData) && (await modifyVehicleDetail(newData));
  roOrPoHasChanged(newData, oldData) && (await modifyROandPOData(newData));
  custodyHasChanged(newData, oldData) && (await modifyCustodyData(newData));
  return Promise.resolve();
};

function basicDataHasChanged(newData, oldData) {
  return (
    newData.vin !== oldData.vin ||
    newData.make !== oldData.make ||
    newData.model !== oldData.model ||
    newData.year !== oldData.year ||
    newData.color !== oldData.color
  );
}

function roOrPoHasChanged(newData, oldData) {
  return newData.ro !== oldData.ro || newData.po !== oldData.po;
}

function custodyHasChanged(newData, oldData) {
  return newData.custody.stockNumber !== oldData.custody.stockNumber;
}

async function modifyCustodyData(newData) {
  return await amplifyApi(
    { stock_number: newData.custody.stockNumber },
    EndPoints.ORDERS.EDIT_CUSTODY.ENDPOINT.replace(
      '{custodyId}',
      newData.custody.custodyId
    ),
    EndPoints.ORDERS.EDIT_CUSTODY.METHOD
  );
}

async function modifyROandPOData(newData) {
  return await amplifyApi(
    {
      dealer_purchase_order_number: newData.po,
      repair_order: newData.ro,
    },
    EndPoints.ORDERS.EDIT_DATA.ENDPOINT.replace('{orderId}', newData.orderId),
    EndPoints.ORDERS.EDIT_DATA.METHOD
  );
}

async function modifyVehicleDetail(newData) {
  return await amplifyApi(
    {
      make: newData.make,
      model: newData.model,
      year: newData.year,
      color: newData.color,
      vin_number: newData.vin,
    },
    EndPoints.ORDERS.NEW_ORDER.EDIT_VEHICLE_DETAIL.ENDPOINT.replace(
      '{vehicleId}',
      newData.vehicleId
    ),
    EndPoints.ORDERS.NEW_ORDER.EDIT_VEHICLE_DETAIL.METHOD
  );
}
